/* eslint-disable default-case */
import { makeActionCreator } from 'es6/helpers/redux';

export const FACEBOOK_LOAD = 'auth/facebook/FACEBOOK_LOAD';
export const FACEBOOK_LOADED = 'auth/facebook/FACEBOOK_LOADED';
export const FACEBOOK_RESPONSE = 'auth/facebook/FACEBOOK_RESPONSE';

export const facebookLoad = makeActionCreator(FACEBOOK_LOAD);
export const facebookLoaded = makeActionCreator(FACEBOOK_LOADED);

/**
 * Action for facebook authentication.
 *
 * @param {Object} response         response from facebook login
 * @param {String} response.status
 * @param {Object} response.authResponse
 */
export function facebookResponse(response = {}) {
  const { authResponse, status } = response;
  return Object.assign({ type: FACEBOOK_RESPONSE }, { authResponse, status });
}

const DEFAULT_STATE = { isLoaded: false };

export default function reducer(state = DEFAULT_STATE, action = {}) {
  const { authResponse, status, type } = action;

  switch (type) {
    case FACEBOOK_LOADED:
      return Object.assign({}, state, { isLoaded: true });
    case FACEBOOK_RESPONSE:
      return Object.assign({}, state, { authResponse, status });
  }

  return state;
}
